import { createFileRoute } from "@tanstack/react-router";
import { StartSeite } from "@/components/StartSeite";

/*
 * Neutraler Einstieg: Anmeldung oder erste freigeschaltete Ansicht.
 * Die Sitzungszustände und Weiterleitungen liegen in StartSeite.
 */
export const Route = createFileRoute("/")({
  component: StartSeite,
});
